import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {Store} from '@ngrx/store';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {BaseLokalizacjaUszkodzenComponent} from '../base-lokalizacja-uszkodzen.component';
import {
  ParametryOszklenWitrazy,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';

@Component({
  selector: 'app-oszklenia-witraze',
  templateUrl: './oszklenia-witraze.component.html',
  styleUrls: ['oszklenia-witraze.component.scss']
})

export class OszkleniaWitrazeComponent extends BaseLokalizacjaUszkodzenComponent implements OnInit {

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  ngOnInit(): void {
    super.ngOnInit();
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.SZYBA_STOLARKA_DREWNIANA, SlownikUszkodzen.SZYBA_STOLARKA_ALUMINIOWA,
      SlownikUszkodzen.SZYBA_STOLARKA_PCV_1, SlownikUszkodzen.SZYBA_STOLARKA_PCV_2, SlownikUszkodzen.SZYBA_ANTYWLAMANIOWA,
      SlownikUszkodzen.SZYBA_KULOODPORNA, SlownikUszkodzen.SZYBA_BEZPIECZNA, SlownikUszkodzen.LUSTRO_STALE,
      SlownikUszkodzen.SZYBA_KOMINKOWA, SlownikUszkodzen.INNE];
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.OSZKLENIA_WITRAZE;
  }

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
  }

  iniciujFormularz(): void {
    return;
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen;

    const wybraneUszkodzenia = this.uszkodzenia
      .filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid) && element.czyUszkodzenieWybraneNaFormularzu())
    const uszkodzeniaPojedyncze = this.utworzUszkodzeniaPojedynczeDlaPrzedmiotowSzklanych<ParametryOszklenWitrazy>(wybraneUszkodzenia);
    const uszkodzeniaGrupowe = this.utworzUszkodzeniaGrupowe<ParametryOszklenWitrazy>(wybraneUszkodzenia);

    const uszkodzenia = uszkodzeniaPojedyncze.concat(uszkodzeniaGrupowe)
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
  }

}
